import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const Home = () => import("@/views/home/");
const News = () => import("@/views/news/");
const Ipo = () => import("@/views/ipo/");
const Disclosure = () => import("@/views/disclosure/");
const DisclosureList = () => import("@/views/disclosureList/");
const DisclosureColumn = () => import("@/views/disclosureColumn/");
const Ecosphere = () => import("@/views/ecosphere/");
const FinancialNews = () => import("@/views/financialNews/");
const Visualization = () => import("@/views/visualization/");
const FinancialNewsInside = () => import("@/views/financialNewsInside/");
const Article = () => import("@/views/article/");
const Corporation = () => import("@/views/corporation/");
const Video = () => import("@/views/video/");
const VideoAll = () => import("@/views/video/home");
const VideoFocus = () => import("@/views/video/focus");
const Agency = () => import("@/views/agency");
const Shuwen = () => import("@/views/Shuwen");
const Search = () => import("@/views/search");
const newShares = () => import("@/views/newShares");
const Picture = () => import("@/views/picture");
const ecosphereIns = () => import("@/views/ecosphereIns");
const MoreList = () => import("@/views/list");
const Bank = () => import("@/views/bank");
const IpoAuth = () => import("@/views/ipoAuth");
const IpoAuthArticle = () => import("@/views/ipoAuth/article/");
const NotFound = () => import("@/views/notFound/");
const VideoArticle = () => import("@/views/VideoArticle/");
const DisclosureSearch = () => import("@/views/disclosureSearch/");
const DisItemIframe = () => import("@/views/disclosureList/disItemIframe/");

const routes = [
  {
    path: "/",
    redirect: "/home",
    hide: true,
  },
  {
    path: "/404",
    name: "NotFound",
    meta: {
      title: "页面不存在",
      icon: "0",
      id: 0,
    },
    hide: true,
    component: NotFound,
  },
  // 所有未定义路由，全部重定向到404页
  {
    path: "*",
    redirect: "/404",
  },
  {
    name: "Home",
    path: "/home",
    component: Home,
    hide: false,
    meta: {
      title: "首页",
      icon: "icon-sy",
      id: 3091829,
      keepAlive: false,
    },
  },
  // 要闻
  {
    name: "News",
    path: "/news",
    redirect: "/news/economics",
    component: News,
    hide: false,
    meta: {
      title: "要闻",
      icon: "icon-yw",
      id: 3091831,
    },
    children: [
      {
        path: "/news/economics",
        name: "News",
        meta: {
          title: "财经要闻",
          icon: "",
          id: 3091857,
        },
      },
      {
        path: "/news/viewPointComment",
        name: "News",
        meta: {
          title: "观点评论",
          icon: "",
          id: 3091858,
        },
      },
      {
        path: "/news/peopleswellbeing",
        name: "News",
        meta: {
          title: "民生消费",
          icon: "",
          id: 3091859,
        },
      },
    ],
  },
  // 公司
  {
    path: "/company",
    name: "Company",
    redirect: "/company/news",
    component: News,
    meta: {
      title: "公司",
      icon: "icon-gs",
      id: 3091833,
    },
    hide: false,
    children: [
      {
        path: "/company/news",
        name: "Company",
        meta: {
          title: "公司要闻",
          icon: "",
          id: 3091870,
        },
      },
      {
        path: "/company/depth",
        name: "Company",
        meta: {
          title: "公司深度",
          icon: "",
          id: 3091871,
        },
      },
      {
        path: "/company/visit",
        name: "Company",
        meta: {
          title: "公司巡礼",
          icon: "",
          id: 0,
        },
      },
    ],
  },
  // 市场
  {
    path: "/marker",
    name: "Marker",
    redirect: "/marker/stock",
    component: News,
    meta: {
      title: "市场",
      icon: "icon-sc",
      id: 3091836,
    },
    hide: false,
    children: [
      {
        path: "/marker/stock",
        name: "Marker",
        meta: {
          title: "市场",
          icon: "",
          id: 3091878,
        },
      },
      {
        path: "/marker/hkstock",
        name: "Marker",
        meta: {
          title: "港股资讯",
          icon: "",
          id: 3091879,
        },
      },
      {
        path: "/marker/bond",
        name: "Marker",
        meta: {
          title: "债市研究",
          icon: "",
          id: 3091880,
        },
      },
      // {
      //   path: "/marker/oversea",
      //   name: "Marker",
      //   meta: {
      //     title: "海外报道",
      //     icon: "",
      //     id: 0,
      //   },
      // },
      // {
      //   path: "/marker/futures",
      //   name: "Marker",
      //   meta: {
      //     title: "期货报道",
      //     icon: "",
      //     id: 0,
      //   },
      // },
    ],
  },
  // 基金
  {
    path: "/fund",
    name: "Fund",
    component: News,
    redirect: "/fund/jjdt",
    meta: {
      title: "基金",
      icon: "icon-jj",
      id: 3091832,
    },
    hide: false,
    children: [
      {
        path: "/fund/jjdt",
        name: "Fund",
        meta: {
          title: "基金动态",
          icon: "",
          id: 3091862,
        },
      },
      {
        path: "/fund/jjks",
        name: "Fund",
        meta: {
          title: "基金视点",
          icon: "",
          id: 3091863,
        },
      },
      // {
      //   path: "/fund/jjcs",
      //   name: "Fund",
      //   meta: {
      //     title: "基金持仓",
      //     icon: "",
      //     id: 3091864,
      //   },
      // },
      {
        path: "/fund/smjj",
        name: "Fund",
        meta: {
          title: "私募基金",
          icon: "",
          id: 3091865,
        },
      },
      // {
      //   path: "/fund/jjcs",
      //   name: "Fund",
      //   meta: {
      //     title: "基民学苑",
      //     icon: "",
      //     id: 3091866,
      //   },
      // },
    ],
  },
  // 机构
  {
    path: "/agency",
    name: "Agency",
    redirect: "/agency/qs",
    component: Agency,
    meta: {
      title: "机构",
      icon: "icon-jg",
      id: 0,
    },
    hide: false,
    children: [
      {
        path: "/agency/qs",
        name: "Agency",
        meta: {
          title: "券商",
          icon: "",
          id: 3091837,
        },
      },
      {
        path: "/agency/bank",
        name: "Agency",
        component: Bank,
        meta: {
          title: "银行",
          icon: "",
          id: 3091884,
        },
      },
      {
        path: "/agency/bx",
        name: "Agency",
        meta: {
          title: "保险",
          icon: "",
          id: 3091844,
        },
      },
    ],
  },
  {
    path: "/bank/:id",
    name: "Bank",
    component: Bank,
    meta: {
      title: "银行",
      icon: "",
      id: 0,
    },
  },
  // 视频
  {
    path: "/video",
    name: "Video",
    redirect: "/video/all",
    component: Video,
    meta: {
      title: "视频",
      icon: "icon-sp",
      id: 0,
    },
    hide: false,
    children: [
      {
        path: "/video/all",
        name: "Video",
        component: VideoAll,
        meta: {
          title: "全部",
          icon: "",
          id: 0,
        },
      },
      {
        path: "/video/jrtt",
        name: "Video",
        component: VideoFocus,
        meta: {
          title: "今日聚焦",
          icon: "",
          id: 178,
        },
      },
      {
        path: "/video/cwqz",
        name: "Video",
        component: VideoFocus,
        meta: {
          title: "传闻求证",
          icon: "",
          id: 150,
        },
      },
      // {
      //   path: "/video/zzkp",
      //   name: "Video",
      //   component: VideoFocus,
      //   meta: {
      //     title: "中证看盘",
      //     icon: "",
      //     id: 151,
      //   },
      // },
      {
        path: "/video/gdft",
        name: "Video",
        component: VideoFocus,
        meta: {
          title: "高端访谈",
          icon: "",
          id: 152,
        },
      },
      {
        path: "/video/tjkt",
        name: "Video",
        component: VideoFocus,
        meta: {
          title: "投教课堂",
          icon: "",
          id: 153,
        },
      },
      // {
      //   path: "/video/zbh",
      //   name: "Video",
      //   component: VideoFocus,
      //   meta: {
      //     title: "直播汇",
      //     icon: "",
      //     id: 0,
      //   },
      // },
    ],
  },

  // ipo
  {
    path: "/ipo",
    name: "Ipo",
    component: Ipo,
    meta: {
      title: "IPO专题",
      icon: "icon-zt",
      id: 0,
    },
    hide: false,
  },

  // 信披
  {
    path: "/disclosure",
    name: "Disclosure",
    component: Disclosure,
    redirect: "/disclosure/ipo",
    meta: {
      title: "信披",
      icon: "icon-xp",
      id: 10000,
    },
    hide: false,
    children: [
      {
        name: "Disclosure",
        path: "/disclosure/all",
        redirect: "/disclosure/ipo",
        component: DisclosureList,
        meta: {
          title: "信息披露",
          icon: "",
          id: 11000,
        },
        children: [
          {
            name: "Disclosure",
            path: "/disclosure/ipo",
            component: DisclosureColumn,
            meta: {
              title: "IPO披露",
              icon: "",
              id: 1,
              infoId: "info3060",
            },
          },
          {
            name: "Disclosure",
            path: "/disclosure/hushi",
            component: DisclosureColumn,
            meta: {
              title: "沪市",
              icon: "",
              id: 2,
              infoId: "info3015",
            },
          },
          {
            name: "Disclosure",
            path: "/disclosure/shenshi",
            component: DisclosureColumn,
            meta: {
              title: "深市",
              icon: "",
              id: 3,
              infoId: "info3015",
            },
          },
          {
            name: "Disclosure",
            path: "/disclosure/beijiao",
            component: DisclosureColumn,
            meta: {
              title: "北交所",
              icon: "",
              id: 4,
              infoId: "info3015",
            },
          },
          {
            name: "Disclosure",
            path: "/disclosure/xinsanban",
            component: DisclosureColumn,
            meta: {
              title: "新三板",
              icon: "",
              id: 5,
              infoId: "info3015",
            },
          },
          // 新加
          {
            name: "Disclosure",
            path: "/disclosure/hugutong",
            component: DisclosureColumn,
            meta: {
              title: "沪股通",
              icon: "",
              id: 31,
              infoId: "info3015",
            },
          },
          {
            name: "Disclosure",
            path: "/disclosure/shengutong",
            component: DisclosureColumn,
            meta: {
              title: "深股通",
              icon: "",
              id: 32,
              infoId: "info3015",
            },
          },
          //
          {
            name: "Disclosure",
            path: "/disclosure/jijin",
            component: DisclosureColumn,
            meta: {
              title: "基金",
              icon: "",
              id: 6,
              infoId: "info3011",
            },
          },
          {
            name: "Disclosure",
            path: "/disclosure/zaiquan",
            component: DisclosureColumn,
            meta: {
              title: "债券",
              icon: "",
              id: 7,
              infoId: "info3012",
            },
          },
          {
            name: "Disclosure",
            path: "/disclosure/jianguan",
            component: DisclosureColumn,
            meta: {
              title: "监管机构",
              icon: "",
              id: 8,
              infoId: "info3063",
            },
          },
        ],
      },
    ],
  },

  // 信披列表
  {
    path: "/disclosureColumn/:id",
    name: "DisclosureColumn",
    component: DisclosureColumn,
    meta: {
      title: "信息披露",
      icon: "",
      id: 11100,
    },
    hide: true,
  },
  // // 直播
  // {
  //   path: "/live",
  //   name: "Live",
  //   redirect: "/live/all",
  //   component: News,
  //   meta: {
  //     title: "直播",
  //     icon: "",
  //     id: 0,
  //   },
  //   hide: false,
  //   children: [
  //     {
  //       path: "/live/all",
  //       name: "Live",
  //       meta: {
  //         title: "全部",
  //         icon: "",
  //         id: 0,
  //       },
  //     },
  //     {
  //       path: "/live/jnj",
  //       name: "Live",
  //       meta: {
  //         title: "金牛奖",
  //         icon: "",
  //         id: 0,
  //       },
  //     },
  //     {
  //       path: "/live/jhzz",
  //       name: "Live",
  //       meta: {
  //         title: "建行·中证报金牛基金巡讲",
  //         icon: "",
  //         id: 0,
  //       },
  //     },
  //     {
  //       path: "/live/tjyd",
  //       name: "Live",
  //       meta: {
  //         title: "投基有道",
  //         icon: "",
  //         id: 0,
  //       },
  //     },
  //     {
  //       path: "/live/jnll",
  //       name: "Live",
  //       meta: {
  //         title: "金牛来了",
  //         icon: "",
  //         id: 0,
  //       },
  //     },
  //     {
  //       path: "/live/zzdjh",
  //       name: "Live",
  //       meta: {
  //         title: "中证点金汇",
  //         icon: "",
  //         id: 0,
  //       },
  //     },
  //     {
  //       path: "/live/zzly",
  //       name: "Live",
  //       meta: {
  //         title: "中证路演",
  //         icon: "",
  //         id: 0,
  //       },
  //     },
  //   ],
  // },

  // 金牛生态圈
  {
    path: "/ecosphere",
    name: "Ecosphere",
    component: Ecosphere,
    hide: false,
    meta: {
      title: "金牛生态圈",
      icon: "icon-jnzq",
      id: 0,
    },
  },
  // 中证智能财讯
  {
    path: "/financialNews",
    name: "FinancialNews",
    component: FinancialNews,
    meta: {
      title: "中证智能财讯",
      icon: "",
      id: 0,
    },
    hide: true,
  },
  // 财报可视化
  {
    path: "/visualization",
    name: "Visualization",
    component: Visualization,
    meta: {
      title: "财报可视化",
      icon: "",
      id: 5091931,
    },
    hide: true,
  },
  // 7 * 24 小时快讯
  {
    path: "/financialNewsInside",
    name: "FinancialNewsInside",
    component: FinancialNewsInside,
    meta: {
      title: "7 * 24 小时快讯",
      icon: "",
      id: 3091848,
    },
    hide: true,
  },
  // IPO鉴真
  {
    path: "/ipoauth",
    name: "Ipoauth",
    component: IpoAuth,
    meta: {
      title: "IPO鉴真",
      icon: "",
      id: 5091931,
    },
    hide: true,
  },
  // IPO鉴真文章
  {
    path: "/article/ipoauth/:id",
    name: "Ipoauth",
    component: IpoAuthArticle,
    meta: {
      title: "文章",
      icon: "",
      id: 0,
    },
    hide: true,
  },
  // 文章
  {
    path: "/article/:id",
    name: "Article",
    component: Article,
    meta: {
      title: "文章",
      icon: "",
      id: 0,
    },
    hide: true,
  },
  // IPO详情
  {
    path: "/corporation/:id",
    name: "Corporation",
    component: Corporation,
    meta: {
      title: "IPO详情",
      icon: "",
      id: 0,
    },
    hide: true,
  },
  // 智能财讯内页
  {
    path: "/shuwen/:id",
    name: "Shuwen",
    component: Shuwen,
    meta: {
      title: "智能财讯内页",
      icon: "",
      id: 0,
    },
    hide: true,
  },
  // 智能财讯内页
  {
    path: "/search",
    name: "Search",
    component: Search,
    meta: {
      title: "搜索",
      icon: "",
      id: 0,
      keepAlive: true,
    },
    hide: true,
  },
  // 今日新股
  {
    path: "/newShares",
    name: "NewShares",
    component: newShares,
    meta: {
      title: "今日新股",
      icon: "",
      id: 0,
    },
    hide: true,
  },
  // 图片展示
  {
    path: "/picture/:id",
    name: "Picture",
    component: Picture,
    meta: {
      title: "一图读财报",
      icon: "",
      id: 0,
    },
    hide: true,
  },
  // 金牛生态圈内页
  {
    path: "/ecosphereIns/:id/:title",
    name: "ecosphereIns",
    component: ecosphereIns,
    meta: {
      title: "",
      icon: "",
      id: 0,
    },
    hide: true,
  },
  // 更多列表页  MoreList
  {
    path: "/moreList/:type/:id",
    name: "moreList",
    component: MoreList,
    meta: {
      title: "",
      icon: "",
      id: 0,
    },
    hide: true,
  },
  {
    path: "/videoArticle",
    name: "videoArticle",
    component: VideoArticle,
    meta: {
      title: "视频详情",
      icon: "",
      id: 0,
    },
    hide: true,
  },
  {
    path: "/disclosureSearch",
    name: "DisclosureSearch",
    component: DisclosureSearch,
    meta: {
      title: "信息披露搜索",
      icon: "",
      id: 0,
      keepAlive: true,
    },
    hide: true,
  },
  {
    name: "disItemIframe",
    path: "/disclosureList/disItemIframe",
    component: DisItemIframe,
    meta: {
      title: "pdf预览",
      icon: "",
      id: 0,
    },
    hide: true,
  },
];

const router = new VueRouter({
  // mode: "history",
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // return 期望滚动到哪个的位置
    return {
      y: 0,
    };
  },
});

// console.log(to, 'to')
//     console.log(from, 'from')
//     if(to.name === 'Search' && from.name === 'Home') {
//       console.log('12312123=====');
//     }
// router.beforeEach((to, from, next) => {
//   if (to.name === 'Search' && from.name === 'Home') {
//     // console.log('12312123=====');
//   }
//   next();
// })

export default router;
